<!-- ABOUT_LINKS -->
<div>
  <h5>SOCIAL</h5>
  <a href="https://x.com/shitonnear"><button>TWITTER</button></a>
  <br />
  <a href="https://t.me/huggiesdotnear"><button>TELEGRAM</button></a>
  <br />
  <a href="https://huggies.near.social/"><button>NEAR SOCIAL</button></a>
  <br />
  <a href="https://github.com/huggiesdotnear"><button>GITHUB</button></a>
</div>
